import { gql } from '@apollo/client';

import { MultipleChoiceExercise } from '../../types';
import { multipleChoiceExerciseFragment } from '../fragments';

export interface GetMultipleChoiceExerciseQueryVariables {
  courseId: string;
  subjectId: string;
  exerciseId?: string;
}

export interface GetMultipleChoiceExerciseQueryResult {
  multipleChoiceExercise: MultipleChoiceExercise;
}

export const getMultipleChoiceExerciseQuery = gql`
  query GetMultipleChoiceExerciseQuery($courseId: String!, $subjectId: String!, $exerciseId: String!) {
    multipleChoiceExercise(courseId: $courseId, subjectId: $subjectId, exerciseId: $exerciseId)
      @rest(type: "Exercise", path: "courses/{args.courseId}/subjects/{args.subjectId}/exercises/{args.exerciseId}") {
      ...MultipleChoiceExercise
    }
  }
  ${multipleChoiceExerciseFragment}
`;
